<IRadioGroup
  name="dspMedia"
  *transloco="let t"
  class="flex flex-col gap-2"
  [value]="media()"
  (valueChange)="select($event)"
>
  @for (option of options; track option.media) {
    @let disabled = option.media === Media.VIDEO_DEAL ? !videoDealAvailable() : !stvAvailable();
    <label
      iLabel
      class="relative w-full max-w-160 rounded-xl border p-4"
      [for]="option.media"
      [class.disabled]="disabled"
      type="card"
    >
      <div class="flex items-start gap-4">
        <IIcon [name]="option.icon" class="text-2xl" [class.text-main]="media() === option.media" />
        <div class="pr-6">
          <span class="type-body-medium block pr-8">{{ t(option.title) }}</span>
          <p class="text-muted-foreground m-0">{{ t(option.description) }}</p>
          @if (disabled && option.media === Media.VIDEO_DEAL) {
            <p class="text-muted-foreground m-0">{{ t("dsp-media-selector.video_deal_no_deal") }}</p>
            <app-dsp-deal-refresh-button />
          }
        </div>
      </div>
      <IRadio [id]="option.media" [value]="option.media" size="lg" class="absolute top-4 right-4" />
    </label>
  }
</IRadioGroup>
